<div [formGroup]="parentForm">
  <div formGroupName="beatmapGoals">
    <label>Beatmap goals (select at least one)</label>
    <div class="grouped fields" [class.error]="hasError('beatmapGoals')">
      <div class="field">
        <sui-checkbox formControlName="rank1">
          Rank 1 on leaderboard
        </sui-checkbox>
      </div>
      <div class="field">
        <sui-checkbox formControlName="fc">
          Must Full Combo
        </sui-checkbox>
      </div>
      <div class="field">
        <sui-checkbox formControlName="misses">
          Max. number of misses
        </sui-checkbox>
      </div>
      <div class="field">
        <sui-checkbox formControlName="accuracy">
          % Accuracy
        </sui-checkbox>
      </div>
      <div class="field">
        <sui-checkbox formControlName="no_difficulty_reduction">
          Disallow difficulty-reduction mods (EZ,
          HalfTime, NoFail, Relax, AP, SO etc)
        </sui-checkbox>
      </div>
      <div class="field">
        <sui-checkbox formControlName="mods">
          Must use specific mods
        </sui-checkbox>
      </div>
    </div>
  </div>
  <div class="field" *ngIf="hasMisses">
    <label>Number of misses acceptable</label>
    <input type="number" name="reward" placeholder="20" formControlName="numberOfMisses" [class.error]="hasError('numberOfMisses')">
  </div>

  <div class="field" *ngIf="hasAccuracy">
    <label>Required Accuracy %</label>
    <input type="number" name="reward" placeholder="99.5" formControlName="accuracy" [class.error]="hasError('accuracy')">
  </div>

  <div class="field" *ngIf="hasMods">
    <label>Select which mods you want</label>
    <div class="inline fields" [class.error]="hasError('mods')" formGroupName="mods">
      <div class="field" *ngFor="let mod of modsArray">
        <sui-checkbox formControlName="{{mod}}">
          {{ mod | uppercase }}
        </sui-checkbox>
      </div>
    </div>
  </div>
</div>
